import store from '../store/index';
import i18n from '@/lang/index';
import { hasGivenPermission } from '@/util/permissions';
import { ROUTES_CHALLENGES, ROUTES_CHALLENGE_TEAM_FORM, ROUTES_HOME } from '@/constants/routes';
import get from 'get-object-path';

export default {
    path: '/challenges',
    name: 'challenges-main',
    component: () => import(/*webpackChunkName: 'challenges'*/ '@/views/Challenges.vue'),
    children: [
        {
            path: '/challenges',
            name: ROUTES_CHALLENGES,
            beforeEnter: guardRouteChallenges,
            component: () => import(/*webpackChunkName: 'challenges'*/ '@/components/challenges/secured/Challenges.vue')
        },
        {
            path: '/challenges/:challengeId/add-challenge-team/:teamId?',
            name: ROUTES_CHALLENGE_TEAM_FORM,
            beforeEnter: guardRouteChallengeTeamForm,
            component: () =>
                import(/*webpackChunkName: 'challenges'*/ '@/components/challenges/secured/overview/ChallengeTeamForm.vue')
        }
    ]
};

function guardRouteChallenges(to, from, next) {
    const isSelectedClubIndividual = get(store.getters.selectedClub, 'club.data.is_individual');

    if (isSelectedClubIndividual) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_HOME });
    } else {
        next();
    }
}

function guardRouteChallengeTeamForm(to, from, next) {
    const canNotCreate = !to.params.paramsTeamId && !hasGivenPermission('create-squads');
    const canNotEdit = to.params.paramsTeamId && !hasGivenPermission('edit-squads');

    if (store.getters.isSelectedClubIndividual || canNotCreate || canNotEdit) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_CHALLENGES });
    } else {
        next();
    }
}
